var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDollarShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 86,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-3.2%",
    y: "-3.8%",
    width: "106.4%",
    height: "110.8%",
    filterUnits: "objectBoundingBox",
    id: "icon-dollar-shield_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0",
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0",
    "in": "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-dollar-shield_svg__a)",
    transform: "translate(-171 -65)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260 140c0 2.21-17.91 4-40 4-22.093 0-40-1.79-40-4s17.907-4 40-4c22.09 0 40 1.79 40 4",
    fill: "#10C98F",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194 135.014h10.893c.035 0 .071 0 .107-.014",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194 134.168a3.288 3.288 0 01-2.2.832h-10.616c-1.76 0-3.184-1.348-3.184-3 0-1.658 1.424-3 3.184-3h10.617",
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197 128h-13.809c-1.762 0-3.191-1.34-3.191-3.002 0-1.655 1.43-2.998 3.191-2.998h10.63c1.668 0 3.038 1.205 3.179 2.738",
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "#C3F1E3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 121.033c-.574.596-1.4.967-2.32.967h-10.523c-1.742 0-3.157-1.342-3.157-2.998 0-1.659 1.415-3.002 3.157-3.002h4.931",
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 135h6.716c1.807 0 3.284-1.348 3.284-3s-1.477-3-3.284-3h-.996M262 132c0-1.658-1.427-3-3.189-3H248.19c-1.763 0-3.189 1.342-3.189 3 0 1.65 1.426 3 3.189 3h10.622c1.762 0 3.189-1.35 3.189-3z",
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "#C3F1E3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.613 122.405a3.301 3.301 0 011.576-.405h10.639c1.756 0 3.172 1.348 3.172 3 0 1.669-1.416 3-3.172 3h-10.639c-1.72 0-3.116-1.264-3.171-2.882-.018-.034-.018-.084-.018-.118",
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.387 128.405a3.301 3.301 0 00-1.576-.405h-10.639c-1.756 0-3.172 1.348-3.172 3 0 1.669 1.416 3 3.172 3h10.639c1.72 0 3.116-1.264 3.171-2.882.018-.034.018-.084.018-.118M247.239 116h10.546c1.77 0 3.215 1.348 3.215 3s-1.446 3-3.215 3h-10.708a3.27 3.27 0 01-2.077-.725M200.761 116h-10.546c-1.77 0-3.215 1.348-3.215 3s1.446 3 3.215 3h10.708a3.27 3.27 0 002.077-.725",
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "#C3F1E3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.015 128H241",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.776 70.43a2.11 2.11 0 00-2.55 0c-6.622 5.037-14.636 8.573-23.402 9.82A2.134 2.134 0 00195 82.374v18.76c0 17.375 10.507 32.407 25.699 38.706.512.212 1.09.212 1.605 0C237.489 133.544 248 118.52 248 101.134V82.371a2.13 2.13 0 00-1.824-2.122c-8.766-1.25-16.776-4.782-23.4-9.82z",
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239 105.002c0 9.391-7.61 16.998-17 16.998-9.392 0-17-7.607-17-16.998C205 95.61 212.608 88 222 88c9.39 0 17 7.61 17 17.002z",
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "#C3F1E3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 110.5c0 2.478 2.014 4.5 4.5 4.5a4.5 4.5 0 000-9.001 4.5 4.5 0 114.5-4.502M222 97v-3M222 117v-3",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
export default SvgIconDollarShield;